module.exports = __webpack_public_path__ + "static/media/chat-bubble.912cc4c1.PNG";